import React, { useState } from "react";
import "./orderKit.scss";
import Layout from "../Layouts/layout";
import useAlertUtils from "../../../utils/common.utils";

const OrderKit = () => {
  const kits = [
    {
      name: "Optimal Hormone Comprehensive",
      code: "OPTIMAL_HORMONE_COMPREHENSIVE",
      panels: [
        {
          name: "Saliva Profile III",
          code: "SALIVA3",
          price: 250,
        },
      ],
    },
    {
      name: "Optimal Adrenal Stress",
      code: "OPTIMAL_ADRENAL_STRESS",
      panels: [
        {
          name: "Adrenal Stress Profile",
          code: "ADRSTRESS",
          price: 160,
        },
      ],
    },
    {
      name: "Optimal Hormone Fundamental 5",
      code: "OPTIMAL_HORMONE_FUNDAMENTAL_5",
      panels: [
        {
          name: "Saliva Profile I",
          code: "SALIVA1",
          price: 170,
        },
      ],
    },
    {
      name: "Optimal Heart Health",
      code: "OPTIMAL_HEART_HEALTH",
      panels: [
        {
          name: "CardioMetabolic Profile",
          code: "CARDIOV2",
          price: 184,
        },
      ],
    },
    {
      name: "Optimal Menopause Kit",
      code: "OPTIMAL_MENOPAUSE",
      panels: [
        {
          name: "Luteinizing Hormone",
          code: "LuteHormLhBlooSpotEcli",
          price: 86,
        },
        {
          name: "Follicle-Stimulating Hormone",
          code: "FolStiHorFshBloSpoEcl",
          price: 86,
        },
      ],
    },
    {
      name: "Optimal Thyroid Health Kit",
      code: "OPTIMAL_THYROID",
      panels: [
        {
          name: "Thyroid-Stimulating Hormone",
          code: "ThyStiHorTshBloSpoEcl",
          price: 79,
        },
        {
          name: "Essential Thyroid Profile",
          code: "ESSTHYV2",
          price: 175,
        },
      ],
    },
    {
      name: "Optilize Vitamin D Kit",
      code: "OPTIMAL_VITD",
      panels: [
        {
          name: "Vitamin D, 25-OH, Total",
          code: "VITD",
          price: 86,
        },
      ],
    },
    {
      name: "Optilize Estrogen Dominence",
      code: "OPTIMAL_ESTDOM",
      panels: [
        {
          name: "Estradiol",
          code: "S_EIA_E2",
          price: 25,
        },
        {
          name: "Progesterone",
          code: "S_EIA_PG",
          price: 25,
        },
      ],
    },
    {
      name: "Optimal Hormone Health Essential 3",
      code: "OPTIMAL_HORMONE_ESSENTIAL_3",
      panels: [
        {
          name: "Hormone Trio",
          code: "SALIVATRIO",
          price: 125,
        },
      ],
    },
    {
      name: "Blood Spot Kit",
      code: "BLOOD_SPOT",
      panels: [
        {
          name: "Sex Hormone Binding Globulin",
          code: "SexHorBinGloShbBloSpoEcl",
          price: 79,
        },
        {
          name: "Prostate-Specific Antigen",
          code: "ProSpeAntPsaBloSpoEcl",
          price: 79,
        },
        {
          name: "Thyroglobulin",
          code: "ThyroTgbnBloodSpotEclia",
          price: 79,
        },
        {
          name: "Total Thyroxine",
          code: "TotaThyrTt4BlooSpotEcli",
          price: 32.5,
        },
        {
          name: "Thyroid-Stimulating Hormone",
          code: "ThyStiHorTshBloSpoEcl",
          price: 79,
        },
        {
          name: "Luteinizing Hormone",
          code: "LuteHormLhBlooSpotEcli",
          price: 86,
        },
        {
          name: "Follicle-Stimulating Hormone",
          code: "FolStiHorFshBloSpoEcl",
          price: 86,
        },
        {
          name: "Insulin, Fasting",
          code: "B_EIA_IN",
          price: 35,
        },
        {
          name: "High-Sensitivity C-Reactive Protein",
          code: "B_EIA_HSCRP",
          price: 86,
        },
        {
          name: "Hemoglobin A1c",
          code: "HemoA1cHba1BlooSpotPhot",
          price: 86,
        },
        {
          name: "Anti-Mullerian Hormone",
          code: "AntiMullHormAmhBlooSpotEcli",
          price: 55,
        },
        {
          name: "CardioMetabolic Profile",
          code: "CARDIOV2",
          price: 184,
        },
        {
          name: "Elite Thyroid Profile",
          code: "ELITETHYV2",
          price: 289,
        },
        {
          name: "Essential Thyroid Profile",
          code: "ESSTHYV2",
          price: 175,
        },
        {
          name: "Female Blood Profile I",
          code: "FBLOOD1V2",
          price: 189,
        },
        {
          name: "Female Blood Profile II",
          code: "FBLOOD2V2",
          price: 349,
        },
        {
          name: "Male Blood Profile I",
          code: "MBLOOD1V2",
          price: 189,
        },
        {
          name: "Male Blood Profile II",
          code: "MBLOOD2V2",
          price: 349,
        },
        {
          name: "Hormone Trio",
          code: "BLOODTRIO",
          price: 130,
        },
        {
          name: "Vitamin D, 25-OH, Total",
          code: "VITD",
          price: 86,
        },
        {
          name: "Toxic & Essential Elements Profile",
          code: "BSELEMENTS",
          price: 129,
        },
      ],
    },
    {
      name: "Saliva Kit",
      code: "SALIVA",
      panels: [
        {
          name: "Estradiol",
          code: "S_EIA_E2",
          price: 25,
        },
        {
          name: "Progesterone",
          code: "S_EIA_PG",
          price: 25,
        },
        {
          name: "Testosterone",
          code: "S_LIA_T",
          price: 25,
        },
        {
          name: "DHEA-S",
          code: "S_EIA_DS",
          price: 25,
        },
        {
          name: "Cortisol",
          code: "S_EIA_C",
          price: 86,
        },
        {
          name: "Saliva Profile I",
          code: "SALIVA1",
          price: 170,
        },
        {
          name: "Saliva Profile II",
          code: "SALIVA2",
          price: 190,
        },
        {
          name: "Saliva Profile III",
          code: "SALIVA3",
          price: 250,
        },
        {
          name: "Adrenal Stress Profile",
          code: "ADRSTRESS",
          price: 160,
        },
        {
          name: "Hormone Trio",
          code: "SALIVATRIO",
          price: 125,
        },
        {
          name: "Diurnal Cortisol",
          code: "CORTX4",
          price: 135,
        },
        {
          name: "Saliva Steroid LCMS Profile 7",
          code: "ZRT-S-2022107-02",
          price: 130,
        },
        {
          name: "Saliva Steroid LCMS Profile 23",
          code: "S_LCMS_P1",
          price: 230,
        },
      ],
    },
    {
      name: "Saliva Blood Combo Kit",
      code: "SALIVA_BLOOD_COMBO",
      panels: [
        {
          name: "Estradiol",
          code: "S_EIA_E2",
          price: 25,
        },
        {
          name: "Progesterone",
          code: "S_EIA_PG",
          price: 25,
        },
        {
          name: "Testosterone",
          code: "S_LIA_T",
          price: 25,
        },
        {
          name: "DHEA-S",
          code: "S_EIA_DS",
          price: 25,
        },
        {
          name: "Cortisol",
          code: "S_EIA_C",
          price: 86,
        },
        {
          name: "Sex Hormone Binding Globulin",
          code: "SexHorBinGloShbBloSpoEcl",
          price: 79,
        },
        {
          name: "Prostate-Specific Antigen",
          code: "ProSpeAntPsaBloSpoEcl",
          price: 79,
        },
        {
          name: "Thyroglobulin",
          code: "ThyroTgbnBloodSpotEclia",
          price: 79,
        },
        {
          name: "Total Thyroxine",
          code: "TotaThyrTt4BlooSpotEcli",
          price: 32.5,
        },
        {
          name: "Thyroid-Stimulating Hormone",
          code: "ThyStiHorTshBloSpoEcl",
          price: 79,
        },
        {
          name: "Luteinizing Hormone",
          code: "LuteHormLhBlooSpotEcli",
          price: 86,
        },
        {
          name: "Follicle-Stimulating Hormone",
          code: "FolStiHorFshBloSpoEcl",
          price: 86,
        },
        {
          name: "Insulin, Fasting",
          code: "B_EIA_IN",
          price: 35,
        },
        {
          name: "High-Sensitivity C-Reactive Protein",
          code: "B_EIA_HSCRP",
          price: 86,
        },
        {
          name: "Hemoglobin A1c",
          code: "HemoA1cHba1BlooSpotPhot",
          price: 86,
        },
        {
          name: "Anti-Mullerian Hormone",
          code: "AntiMullHormAmhBlooSpotEcli",
          price: 55,
        },
        {
          name: "Saliva Profile I",
          code: "SALIVA1",
          price: 170,
        },
        {
          name: "Saliva Profile II",
          code: "SALIVA2",
          price: 190,
        },
        {
          name: "Saliva Profile III",
          code: "SALIVA3",
          price: 250,
        },
        {
          name: "Adrenal Stress Profile",
          code: "ADRSTRESS",
          price: 160,
        },
        {
          name: "Hormone Trio",
          code: "SALIVATRIO",
          price: 125,
        },
        {
          name: "Diurnal Cortisol",
          code: "CORTX4",
          price: 135,
        },
        {
          name: "Saliva Steroid LCMS Profile 7",
          code: "ZRT-S-2022107-02",
          price: 130,
        },
        {
          name: "Saliva Steroid LCMS Profile 23",
          code: "S_LCMS_P1",
          price: 230,
        },
        {
          name: "CardioMetabolic Profile",
          code: "CARDIOV2",
          price: 184,
        },
        {
          name: "Elite Thyroid Profile",
          code: "ELITETHYV2",
          price: 289,
        },
        {
          name: "Essential Thyroid Profile",
          code: "ESSTHYV2",
          price: 175,
        },
        {
          name: "Female Blood Profile I",
          code: "FBLOOD1V2",
          price: 189,
        },
        {
          name: "Female Blood Profile II",
          code: "FBLOOD2V2",
          price: 349,
        },
        {
          name: "Male Blood Profile I",
          code: "MBLOOD1V2",
          price: 189,
        },
        {
          name: "Male Blood Profile II",
          code: "MBLOOD2V2",
          price: 349,
        },
        {
          name: "Hormone Trio",
          code: "BLOODTRIO",
          price: 130,
        },
        {
          name: "Comprehensive Female Profile I",
          code: "COMPF1V2",
          price: 192.5,
        },
        {
          name: "Comprehensive Female Profile II",
          code: "COMPF2V2",
          price: 215,
        },
        {
          name: "Comprehensive Male Profile I",
          code: "COMPM1V2",
          price: 195,
        },
        {
          name: "Comprehensive Male Profile II",
          code: "COMPM2V2",
          price: 217.5,
        },
        {
          name: "Vitamin D, 25-OH, Total",
          code: "VITD",
          price: 86,
        },
        {
          name: "Toxic & Essential Elements Profile",
          code: "BSELEMENTS",
          price: 129,
        },
      ],
    },
    {
      name: "Saliva Urine Combo Kit",
      code: "SALIVA_URINE_COMBO",
      panels: [
        {
          name: "Estradiol",
          code: "S_EIA_E2",
          price: 25,
        },
        {
          name: "Progesterone",
          code: "S_EIA_PG",
          price: 25,
        },
        {
          name: "Testosterone",
          code: "S_LIA_T",
          price: 25,
        },
        {
          name: "DHEA-S",
          code: "S_EIA_DS",
          price: 25,
        },
        {
          name: "Cortisol",
          code: "S_EIA_C",
          price: 86,
        },
        {
          name: "Saliva Profile I",
          code: "SALIVA1",
          price: 170,
        },
        {
          name: "Saliva Profile II",
          code: "SALIVA2",
          price: 190,
        },
        {
          name: "Saliva Profile III",
          code: "SALIVA3",
          price: 250,
        },
        {
          name: "Adrenal Stress Profile",
          code: "ADRSTRESS",
          price: 160,
        },
        {
          name: "Hormone Trio",
          code: "SALIVATRIO",
          price: 125,
        },
        {
          name: "Diurnal Cortisol",
          code: "CORTX4",
          price: 135,
        },
        {
          name: "Saliva Steroid LCMS Profile 7",
          code: "ZRT-S-2022107-02",
          price: 130,
        },
        {
          name: "Saliva Steroid LCMS Profile 23",
          code: "S_LCMS_P1",
          price: 230,
        },
        {
          name: "Iodine",
          code: "U_ICPMS_I",
          price: 80,
        },
        {
          name: "Toxic & Essential Elements Profile",
          code: "UELEMENTS",
          price: 129,
        },
      ],
    },
    {
      name: "Urine Blood Combo Kit",
      code: "URINE_BLOOD_COMBO",
      panels: [
        {
          name: "Sex Hormone Binding Globulin",
          code: "SexHorBinGloShbBloSpoEcl",
          price: 79,
        },
        {
          name: "Prostate-Specific Antigen",
          code: "ProSpeAntPsaBloSpoEcl",
          price: 79,
        },
        {
          name: "Thyroglobulin",
          code: "ThyroTgbnBloodSpotEclia",
          price: 79,
        },
        {
          name: "Total Thyroxine",
          code: "TotaThyrTt4BlooSpotEcli",
          price: 32.5,
        },
        {
          name: "Thyroid-Stimulating Hormone",
          code: "ThyStiHorTshBloSpoEcl",
          price: 79,
        },
        {
          name: "Luteinizing Hormone",
          code: "LuteHormLhBlooSpotEcli",
          price: 86,
        },
        {
          name: "Follicle-Stimulating Hormone",
          code: "FolStiHorFshBloSpoEcl",
          price: 86,
        },
        {
          name: "Insulin, Fasting",
          code: "B_EIA_IN",
          price: 35,
        },
        {
          name: "High-Sensitivity C-Reactive Protein",
          code: "B_EIA_HSCRP",
          price: 86,
        },
        {
          name: "Hemoglobin A1c",
          code: "HemoA1cHba1BlooSpotPhot",
          price: 86,
        },
        {
          name: "Anti-Mullerian Hormone",
          code: "AntiMullHormAmhBlooSpotEcli",
          price: 55,
        },
        {
          name: "CardioMetabolic Profile",
          code: "CARDIOV2",
          price: 184,
        },
        {
          name: "Elite Thyroid Profile",
          code: "ELITETHYV2",
          price: 289,
        },
        {
          name: "Essential Thyroid Profile",
          code: "ESSTHYV2",
          price: 175,
        },
        {
          name: "Female Blood Profile I",
          code: "FBLOOD1V2",
          price: 189,
        },
        {
          name: "Female Blood Profile II",
          code: "FBLOOD2V2",
          price: 349,
        },
        {
          name: "Male Blood Profile I",
          code: "MBLOOD1V2",
          price: 189,
        },
        {
          name: "Male Blood Profile II",
          code: "MBLOOD2V2",
          price: 349,
        },
        {
          name: "Hormone Trio",
          code: "BLOODTRIO",
          price: 130,
        },
        {
          name: "Vitamin D, 25-OH, Total",
          code: "VITD",
          price: 86,
        },
        {
          name: "Iodine",
          code: "U_ICPMS_I",
          price: 80,
        },
        {
          name: "Toxic & Essential Elements Profile",
          code: "UELEMENTS",
          price: 129,
        },
        {
          name: "Comprehensive Thyroid Profile",
          code: "COMPTHYV2",
          price: 319,
        },
        {
          name: "Toxic & Essential Elements Profile",
          code: "BSELEMENTS",
          price: 129,
        },
        {
          name: "Comprehensive Toxic & Essential Elements Profile",
          code: "COMPELE_ICMPS",
          price: 229,
        },
      ],
    },
    {
      name: "Heavy Metals & Essential Elements Kit",
      code: "HEAVY_METALS_ESSENTIAL_ELEMENTS",
      panels: [
        {
          name: "Elite Thyroid Profile",
          code: "ELITETHYV2",
          price: 289,
        },
        {
          name: "Iodine",
          code: "U_ICPMS_I",
          price: 80,
        },
        {
          name: "Toxic & Essential Elements Profile",
          code: "UELEMENTS",
          price: 129,
        },
        {
          name: "Toxic & Essential Elements Profile",
          code: "BSELEMENTS",
          price: 129,
        },
        {
          name: "Comprehensive Toxic & Essential Elements Profile",
          code: "COMPELE_ICMPS",
          price: 229,
        },
      ],
    },
    {
      name: "Neurotransmitters Kit",
      code: "NEUROTRANSMITTERS",
      panels: [
        {
          name: "Urine Diurnal Hormones (UDH) I",
          code: "U_UDHI",
          price: 245,
        },
        {
          name: "Urine Diurnal Hormones (UDH) II",
          code: "SLEEP",
          price: 245,
        },
        {
          name: "Urine Diurnal Hormones (UDH) III",
          code: "U_UDHIII",
          price: 245,
        },
        {
          name: "Toxic & Essential Elements Profile",
          code: "UELEMENTS",
          price: 129,
        },
        {
          name: "Neurotransmitters",
          code: "U_NEURO_ADV",
          price: 320,
        },
        {
          name: "Neurotransmitters + UDH I",
          code: "U_NEURO_ADV_CCX4",
          price: 320,
        },
        {
          name: "Neurotransmitters + UDH II",
          code: "U_NEURO_ADV_CCMX4",
          price: 320,
        },
        {
          name: "Neurotransmitters + UDH III",
          code: "U_NEURO_ADV_CCMNEX4",
          price: 320,
        },
        {
          name: "Neurotransmitters + Saliva Steroids",
          code: "U_NEURO_ADV_SALIVA",
          price: 320,
        },
        {
          name: "Neurotransmitters + Saliva Steroids + UDH III",
          code: "U_NEURO_S_UDHIII",
          price: 320,
        },
      ],
    },
    {
      name: "Urine Metabolites Kit",
      code: "URINE_METABOLITES",
      panels: [
        {
          name: "Urine Diurnal Hormones (UDH) I",
          code: "U_UDHI",
          price: 245,
        },
        {
          name: "Urine Diurnal Hormones (UDH) II",
          code: "SLEEP",
          price: 245,
        },
        {
          name: "Estrogen Essential",
          code: "MET_E_ESSENTIAL",
          price: 225,
        },
        {
          name: "Sex Steroid Metabolites",
          code: "MET_SSM",
          price: 405,
        },
        {
          name: "Sex Steroid Metabolites + UDH II",
          code: "MET_ADVANCED",
          price: 405,
        },
      ],
    },
    {
      name: "Adrenal Stress Kit",
      code: "ADRENAL_STRESS",
      panels: [
        {
          name: "Adrenal Stress Profile",
          code: "ADRSTRESS",
          price: 160,
        },
      ],
    },
    {
      name: "Weight Management Kit",
      code: "WEIGHT_MANAGEMENT",
      panels: [
        {
          name: "Weight Management",
          code: "WEIGHTMGMTV2",
          price: 335,
        },
        {
          name: "Weight Management + Thyroid",
          code: "SB_WM_THYV2",
          price: 405,
        },
        {
          name: "Weight Management + Cardio",
          code: "SB_WM_CARV2",
          price: 405,
        },
        {
          name: "Weight Management + Thyroid + Cardio",
          code: "SB_WM_THY_CARV2",
          price: 475,
        },
      ],
    },
    {
      name: "Cortisol Awakening Response Kit",
      code: "CORTISOL_AWAKENING_RESPONSE",
      panels: [
        {
          name: "Cortisol Awakening Response Profile",
          code: "S_CAR",
          price: 237,
        },
      ],
    },
    {
      name: "Menstrual Cycle Mapping Kit",
      code: "MENSTRUAL_CYCLE_MAPPING",
      panels: [
        {
          name: "Menstrual Cycle Mapping",
          code: "U_MENSTRUALMAP1",
          price: 469,
        },
      ],
    },
    {
      name: "Sleep Balance Kit",
      code: "SLEEP_BALANCE",
      panels: [
        {
          name: "Urine Diurnal Hormones (UDH) I",
          code: "U_UDHI",
          price: 245,
        },
        {
          name: "Urine Diurnal Hormones (UDH) II",
          code: "SLEEP",
          price: 245,
        },
        {
          name: "Urine Diurnal Hormones (UDH) III",
          code: "U_UDHIII",
          price: 245,
        },
      ],
    },
  ];

  const [selectedKit, setSelectedKit] = useState(kits[0]);
  const [cartCount, setCartCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("featured");
  const [filterBy, setFilterBy] = useState("all");
  const [showSortDropdown, setShowSortDropdown] = useState(false);
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const [showBulkInfoModal, setShowBulkInfoModal] = useState(false);

  const { alertError, alertSuccess } = useAlertUtils();

  const addToCart = (panel, kitName, kitCode) => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    if (cart.length >= 3) {
      setShowBulkInfoModal(true);
      return;
    }
    cart.push({
      kitName: kitName,
      kitCode: kitCode,
      name: panel.name,
      code: panel.code,
      price: panel.price,
      totalPrice: panel.price,
    });
    localStorage.setItem("cart", JSON.stringify(cart));
    updateCartCount();
    alertSuccess(`${panel.name} added to cart ✅`);
  };

  const updateCartCount = () => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    const lineItems = cart.length;
    setCartCount(lineItems);
  };

  React.useEffect(() => {
    updateCartCount();
  }, []);

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest(".sortControl") &&
        !event.target.closest(".filterControl")
      ) {
        setShowSortDropdown(false);
        setShowFilterDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleKitClick = (kit) => {
    setSelectedKit(kit);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const getFilteredAndSortedKits = () => {
    let filteredKits = [...kits];

    if (searchTerm) {
      filteredKits = filteredKits.filter(
        (kit) =>
          kit.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          kit.panels.some((panel) =>
            panel.name.toLowerCase().includes(searchTerm.toLowerCase())
          )
      );
    }

    if (filterBy !== "all") {
      filteredKits = filteredKits.filter((kit) => {
        const kitName = kit.name.toLowerCase();
        switch (filterBy) {
          case "hormone":
            return (
              kitName.includes("hormone") ||
              kitName.includes("estrogen") ||
              kitName.includes("testosterone")
            );
          case "thyroid":
            return kitName.includes("thyroid");
          case "adrenal":
            return kitName.includes("adrenal") || kitName.includes("cortisol");
          case "heart":
            return kitName.includes("heart") || kitName.includes("cardio");
          case "vitamin":
            return kitName.includes("vitamin") || kitName.includes("vitd");
          case "saliva":
            return kitName.includes("saliva");
          case "blood":
            return kitName.includes("blood");
          case "urine":
            return kitName.includes("urine");
          case "combo":
            return kitName.includes("combo");
          case "specialty":
            return (
              kitName.includes("neurotransmitter") ||
              kitName.includes("weight") ||
              kitName.includes("sleep") ||
              kitName.includes("menstrual")
            );
          default:
            return true;
        }
      });
    }

    switch (sortBy) {
      case "name-asc":
        filteredKits.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case "name-desc":
        filteredKits.sort((a, b) => b.name.localeCompare(a.name));
        break;
      case "price-asc":
        filteredKits.sort((a, b) => {
          const aMinPrice = Math.min(...a.panels.map((p) => p.price));
          const bMinPrice = Math.min(...b.panels.map((p) => p.price));
          return aMinPrice - bMinPrice;
        });
        break;
      case "price-desc":
        filteredKits.sort((a, b) => {
          const aMaxPrice = Math.max(...a.panels.map((p) => p.price));
          const bMaxPrice = Math.max(...b.panels.map((p) => p.price));
          return bMaxPrice - aMaxPrice;
        });
        break;
      case "panels-asc":
        filteredKits.sort((a, b) => a.panels.length - b.panels.length);
        break;
      case "panels-desc":
        filteredKits.sort((a, b) => b.panels.length - a.panels.length);
        break;
      default:
        break;
    }

    return filteredKits;
  };

  const filteredKits = getFilteredAndSortedKits();
  React.useEffect(() => {
    if (filteredKits.length > 0) {
      const isCurrentKitInFiltered = filteredKits.some(
        (kit) => kit.code === selectedKit.code
      );
      if (!isCurrentKitInFiltered) {
        setSelectedKit(filteredKits[0]);
      }
    }
  }, [filteredKits, selectedKit.code]);

  const getSortLabel = () => {
    switch (sortBy) {
      case "name-asc":
        return "Name A-Z";
      case "name-desc":
        return "Name Z-A";
      case "price-asc":
        return "Price Low-High";
      case "price-desc":
        return "Price High-Low";
      case "panels-asc":
        return "Fewest Panels";
      case "panels-desc":
        return "Most Panels";
      default:
        return "Featured";
    }
  };

  const getFilterLabel = () => {
    switch (filterBy) {
      case "hormone":
        return "Hormone";
      case "thyroid":
        return "Thyroid";
      case "adrenal":
        return "Adrenal";
      case "heart":
        return "Heart Health";
      case "vitamin":
        return "Vitamin";
      case "saliva":
        return "Saliva";
      case "blood":
        return "Blood";
      case "urine":
        return "Urine";
      case "combo":
        return "Combo Kits";
      case "specialty":
        return "Specialty";
      default:
        return "All Tests";
    }
  };

  return (
    <Layout>
      <div className="testsPage">
        <div className="topBar">
          <div className="topBarLeft">
            <h1 className="pageTitle">ZRT Kits</h1>
          </div>
          <div className="topBarRight">
            <div className="filterControls">
              <div
                className="sortControl"
                onClick={() => setShowSortDropdown(!showSortDropdown)}
              >
                <span className="controlLabel">SORT BY</span>
                <span className="controlValue">{getSortLabel()}</span>
                <span className="chevron">{showSortDropdown ? "▲" : "▼"}</span>
                {showSortDropdown && (
                  <div className="dropdown">
                    <div
                      className="dropdownItem"
                      onClick={() => {
                        setSortBy("featured");
                        setShowSortDropdown(false);
                      }}
                    >
                      Featured
                    </div>
                    <div
                      className="dropdownItem"
                      onClick={() => {
                        setSortBy("name-asc");
                        setShowSortDropdown(false);
                      }}
                    >
                      Name A-Z
                    </div>
                    <div
                      className="dropdownItem"
                      onClick={() => {
                        setSortBy("name-desc");
                        setShowSortDropdown(false);
                      }}
                    >
                      Name Z-A
                    </div>
                    <div
                      className="dropdownItem"
                      onClick={() => {
                        setSortBy("price-asc");
                        setShowSortDropdown(false);
                      }}
                    >
                      Price Low-High
                    </div>
                    <div
                      className="dropdownItem"
                      onClick={() => {
                        setSortBy("price-desc");
                        setShowSortDropdown(false);
                      }}
                    >
                      Price High-Low
                    </div>
                    <div
                      className="dropdownItem"
                      onClick={() => {
                        setSortBy("panels-asc");
                        setShowSortDropdown(false);
                      }}
                    >
                      Fewest Panels
                    </div>
                    <div
                      className="dropdownItem"
                      onClick={() => {
                        setSortBy("panels-desc");
                        setShowSortDropdown(false);
                      }}
                    >
                      Most Panels
                    </div>
                  </div>
                )}
              </div>
              <div className="separator"></div>
              <div
                className="filterControl"
                onClick={() => setShowFilterDropdown(!showFilterDropdown)}
              >
                <span className="controlLabel">FILTER BY</span>
                <span className="controlValue">{getFilterLabel()}</span>
                <span className="chevron">
                  {showFilterDropdown ? "▲" : "▼"}
                </span>
                {showFilterDropdown && (
                  <div className="dropdown">
                    <div
                      className="dropdownItem"
                      onClick={() => {
                        setFilterBy("all");
                        setShowFilterDropdown(false);
                      }}
                    >
                      All Tests
                    </div>
                    <div
                      className="dropdownItem"
                      onClick={() => {
                        setFilterBy("hormone");
                        setShowFilterDropdown(false);
                      }}
                    >
                      Hormone
                    </div>
                    <div
                      className="dropdownItem"
                      onClick={() => {
                        setFilterBy("thyroid");
                        setShowFilterDropdown(false);
                      }}
                    >
                      Thyroid
                    </div>
                    <div
                      className="dropdownItem"
                      onClick={() => {
                        setFilterBy("adrenal");
                        setShowFilterDropdown(false);
                      }}
                    >
                      Adrenal
                    </div>
                    <div
                      className="dropdownItem"
                      onClick={() => {
                        setFilterBy("heart");
                        setShowFilterDropdown(false);
                      }}
                    >
                      Heart Health
                    </div>
                    <div
                      className="dropdownItem"
                      onClick={() => {
                        setFilterBy("vitamin");
                        setShowFilterDropdown(false);
                      }}
                    >
                      Vitamin
                    </div>
                    <div
                      className="dropdownItem"
                      onClick={() => {
                        setFilterBy("saliva");
                        setShowFilterDropdown(false);
                      }}
                    >
                      Saliva
                    </div>
                    <div
                      className="dropdownItem"
                      onClick={() => {
                        setFilterBy("blood");
                        setShowFilterDropdown(false);
                      }}
                    >
                      Blood
                    </div>
                    <div
                      className="dropdownItem"
                      onClick={() => {
                        setFilterBy("urine");
                        setShowFilterDropdown(false);
                      }}
                    >
                      Urine
                    </div>
                    <div
                      className="dropdownItem"
                      onClick={() => {
                        setFilterBy("combo");
                        setShowFilterDropdown(false);
                      }}
                    >
                      Combo Kits
                    </div>
                    <div
                      className="dropdownItem"
                      onClick={() => {
                        setFilterBy("specialty");
                        setShowFilterDropdown(false);
                      }}
                    >
                      Specialty
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="searchControl">
              <div className="searchBar">
                <span className="searchIcon">🔍</span>
                <input
                  type="text"
                  placeholder="Search kits and panels..."
                  className="searchInput"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                {searchTerm && (
                  <button
                    className="clearSearch"
                    onClick={() => setSearchTerm("")}
                  >
                    ✕
                  </button>
                )}
              </div>
            </div>
            <div className="cartControl">
              <a href="/app/kit-cart" className="cartButton">
                🛒
                {cartCount > 0 && (
                  <span className="cartBadge">{cartCount}</span>
                )}
              </a>
            </div>
          </div>
        </div>

        <div className="mainContainer">
          <aside className="sidebar">
            <ul className="kitList">
              {filteredKits.length > 0 ? (
                filteredKits.map((kit, i) => (
                  <li
                    key={i}
                    className={`kitItem ${
                      selectedKit.code === kit.code ? "active" : ""
                    }`}
                    onClick={() => handleKitClick(kit)}
                  >
                    {kit.name}
                  </li>
                ))
              ) : (
                <li className="noResults">
                  No kits found matching your criteria
                </li>
              )}
            </ul>
          </aside>
          <div className="kitsGrid">
            <h2 className="gridTitle">{selectedKit.name}</h2>
            <div className="panelsGrid">
              {selectedKit.panels.map((panel, j) => (
                <div className="kitCard" key={j}>
                  <h3 className="panelName">{panel.name}</h3>
                  <p className="panelPrice">${panel.price}</p>
                  <button
                    className="selectButton"
                    onClick={() =>
                      addToCart(panel, selectedKit.name, selectedKit.code)
                    }
                  >
                    Add to Cart
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {showBulkInfoModal && (
        <div className="paymentModal" role="dialog" aria-modal="true">
          <div className="paymentModalContent">
            <div className="paymentModalHeader">
              <h3>Bulk Order</h3>
              <button
                className="modalCloseBtn"
                onClick={() => setShowBulkInfoModal(false)}
              >
                <span>×</span>
              </button>
            </div>
            <div className="paymentModalBody">
              <div className="paymentAmount" style={{ marginBottom: 12 }}>
                <span className="amountLabel">Ordering more than 3 kits?</span>
              </div>
              <p style={{ margin: 0 }}>
                If you want to order bulk kits, please email us at
              </p>
              <p style={{ fontWeight: 600, marginTop: 6 }}>info@hrt.org</p>
              <div
                style={{
                  marginTop: 16,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <button
                  className="modalCloseBtn"
                  onClick={() => setShowBulkInfoModal(false)}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default OrderKit;
